import React from 'react';
import { motion } from 'framer-motion';
import {
  FiDatabase,
  FiLayers,
  FiMonitor,
  FiServer,
  FiSettings,
  FiSmartphone,
} from 'react-icons/fi';
import SectionHeader from './SectionHeader';

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
};

const icons = [
  <FiMonitor />,
  <FiSettings />,
  <FiLayers />,
  <FiServer />,
  <FiSmartphone />,
  <FiDatabase />,
];

const BuildSection = ({ content }) => (
  <section id="services" className="section section-dark">
    <div className="container section-stack">
      <SectionHeader
        eyebrow={content.eyebrow}
        title={content.title}
        intro={content.intro}
      />

      <div className="build-grid">
        {content.items.map((item, index) => (
          <motion.article
            key={item.title}
            className="build-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
            transition={{ duration: 0.5, delay: index * 0.06 }}
          >
            <div className="build-icon">{icons[index]}</div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <span>{item.value}</span>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default BuildSection;
